import React, { Component } from 'react'
import { connect } from 'react-redux'
import ChangePasswordForm from '../../../components/forms/account/ChangePasswordForm'
import {updateUserPassword} from '../../../actions/user'
import {showNotification} from '../../../actions/notifications'
import errorMessages from '../../../errorMessages.js'

class ChangePasswordContainer extends Component {
  
	constructor(props){
		super(props)
		this.updateUserPassword=this.updateUserPassword.bind(this)

		this.state = {
			submitLoading:false,
			errorMessage:null
		
		}
		
	}


	updateUserPassword(formData) {
		this.setState({submitLoading:true,errorMessage:null})
		const requestData = {
			'currentPassword': formData.currentPassword,
			'newPassword': formData.newPassword
		}
		this.props.updateUserPassword(requestData, this.props.user.id).then((response) => {
			const notificationMessage='your password'
	 		this.props.showNotification(notificationMessage,'Updated','default')
			this.props.hideModal()
		
		}) 
			.catch(error => {
				let errorMessage='Please try again. If the problem persists, contact support.'
				if(errorMessages.accountErrors.updatePassword[error.response.status]){
			 		errorMessage=`${errorMessages.accountErrors.updatePassword[error.response.status]}`
				}
				this.setState({submitLoading:false,errorMessage:errorMessage})
			})
	}




	render() {

		const {errorMessage,submitLoading}=this.state

		return (
			<React.Fragment>	

				<ChangePasswordForm 
					submitLoading={submitLoading}
					onSubmit={this.updateUserPassword}			
				/>

				{errorMessage &&		
					<div className='accountForm-error'>
						{errorMessage}					
					</div>
				}

			</React.Fragment>
		)
	}
}


export default connect(
	(state) => ({
		user:state.user

	}),
	{ updateUserPassword,showNotification}
)(ChangePasswordContainer)





// WEBPACK FOOTER //
// ./src/containers/modals/account/ChangePasswordContainer.js